import { render, staticRenderFns } from "./CustomOptionPopover.vue?vue&type=template&id=6bf63ff6&scoped=true&"
import script from "./CustomOptionPopover.vue?vue&type=script&lang=js&"
export * from "./CustomOptionPopover.vue?vue&type=script&lang=js&"
import style0 from "./CustomOptionPopover.vue?vue&type=style&index=0&id=6bf63ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf63ff6",
  null
  
)

export default component.exports